import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vfaq',
  templateUrl: './vfaq.component.html',
  styleUrls: ['./vfaq.component.css']
})
export class VfaqComponent implements OnInit {
  FAQ={'title':'FAQ','desciprtion':'desciprtion'};
  
  activestatus=false;
  
  constructor() { 
    
  }

  ngOnInit() {
    for(var i=1;i<=11;i++){
      this.activestatus=false;
    }
  }

  funactive(){
    this.activestatus=true;
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vfaq/vfaq.component.ts